import script from "./GroupedVoucherList.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupedVoucherList.vue?vue&type=script&setup=true&lang=ts"

import "./GroupedVoucherList.vue?vue&type=style&index=0&id=7838abe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7838abe2"]])

export default __exports__